import { FileType } from '../enums/FileTypes';
import { CommonFunctions } from '../static/common-functions';

export class CDocument {
  constructor(dataItem: CDocument) {
    if (CommonFunctions.hasValue(dataItem)) {
      this.fileName = dataItem.fileName;
      this.extension = dataItem.extension;
      this.document = dataItem.document;
      this.documentB64String = dataItem.documentB64String;
      this.setProperties();
    }
  }
  fileName: string;
  extension: string;
  document: any;
  documentB64String: string;
  private _fileType: FileType = null;
  private _isImage: boolean = null;
  private _isViewable: boolean = null;
  private _mimeType: string = null;

  get hasDocumentB64String(): boolean {
    return CommonFunctions.hasValue(this.documentB64String);
  }
  get fileType(): FileType {
    if (this._fileType === null) {
      this.setProperties();
    }
    return this._fileType;
  }

  get isImage(): boolean {
    if (this._isImage === null) {
      this.setProperties();
    }
    return this._isImage;
  }
  get isViewable(): boolean {
    if (this._isViewable === null) {
      this.setProperties();
    }
    return this._isViewable;
  }
  get mimeType(): string {
    if (this._mimeType === null) {
      this.setProperties();
    }
    return this._mimeType;
  }
  get fullFileName(): string {

    return this.fileName + this.extension;
  }
  setProperties() {
    this._fileType = FileType.None;
    this._isImage = false;
    this._isViewable = false;
    this._mimeType = "";
    if (this.extension) {
      const lowerExt = this.extension.toLowerCase();
      if (lowerExt.indexOf("txt") > -1) {
        this._fileType = FileType.Txt;
        this._mimeType = "text/plain";
        this._isViewable = true;
      }
      else if (lowerExt.indexOf("pdf") > -1) {
        this._fileType = FileType.Pdf;
        this._mimeType = "application/pdf";
        this._isViewable = true;
      }
      else if (lowerExt.indexOf("png") > -1) {
        this._fileType = FileType.Png;
        this._isImage = true;
        this._mimeType = "image/png";
        this._isViewable = true;
      }
      else if (lowerExt.indexOf("gif") > -1) {
        this._fileType = FileType.Gif;
        this._isImage = true;
        this._mimeType = "image/gif";
        this._isViewable = true;
      }
      else if (lowerExt.indexOf("jpg") > -1 || lowerExt.indexOf("jpeg") > -1) {
        this._fileType = FileType.Jpg;
        this._isImage = true;
        this._mimeType = "image/jpeg";
        this._isViewable = true;
      }
      else if (lowerExt.indexOf("doc") > -1) {
        this._fileType = FileType.Doc;
        this._mimeType = "application/msword";
      }
      else if (lowerExt.indexOf("xls") > -1) {
        this._fileType = FileType.Xls;
        this._mimeType = "application/vnd.ms-excel";//x-excel";
      }
      else if (lowerExt.indexOf("cvs") > -1) {
        this._fileType = FileType.Xls;
        this._mimeType = "application/vnd.ms-excel";//x-excel";
      }
      else if (lowerExt.indexOf("mp4") > -1) {
        this._fileType = FileType.Mp4;
        this._mimeType = "video/mp4";//x-excel";
      }
      else if (lowerExt.indexOf("mov") > -1) {
        this._fileType = FileType.Mov;
        this._mimeType = "video/quicktime";//x-excel";
      }
    }
  }
}
